import React, { Component } from 'react';

export class Home extends Component {
  displayName = Home.name

  render() {
    return (
      <div style={{textAlign:"center"}}>
        <h2>Welcome to SpinRise</h2>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Pages/Home.js